import s3_bg from '../../../assets/images/s3_bg.png';
import right_arrow_white from '../../../assets/images/right_arrow_white.png';
import React, { useEffect, useState } from 'react';
import AOS from 'aos';

export default function Section3() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: 'ease-out',
    });

    setTimeout(() => {
      setIsLoaded(true);
    }, 100);

    AOS.refresh();
  }, []);

  return (
    <>
      <div className="sect3 pt-7 pb-7">
        <div className="center">
          <div className="row-flex s3_content relative m-col-flex">
            <div
              className="s3_content_left relative col-flex 
            txt-left w-35 pl-4 pt-10 m-w-100 m-p-0 t-p-0"
            >
              <p className="prt-medium fs-20 fc-005eed mb-1">Global Network</p>
              <p className="prt-bold fs-50 fc-black1 lh-13 mb-2">
                전국 지점현황
              </p>
              <div
                className="row-flex-center gap-10 s3_viewmore_btn 
                pointer mt-3 mb-7 m-mt-10 m-mb-10"
                onclick="location=''"
              >
                <p className="prt-regular fs-18 fc-white">자세히 보기</p>
                <img src={right_arrow_white} alt="" />
              </div>

              <div
                className="gradient_box1 flex-center col-flex
                 "
              >
                <div
                  className="row-flex-center bd-bottom-ccc
                   prt-medium w-80 pb-4
     m-w-80 m-pb-10px            fs-18 fc-39"
                >
                  <p className="w-50 ">본사</p>
                  <p className="w-50 ">전북 대리점</p>
                </div>

                <div
                  className="row-flex-center bd-bottom-ccc prt-medium w-80 pb-4 pt-3 m-w-80 m-pb-10px
                fs-18 fc-39"
                >
                  <p className="w-50 ">서울운영본부</p>
                  <p className="w-50 ">대구 대리점</p>
                </div>

                <div
                  className="row-flex-center bd-bottom-ccc prt-medium w-80 pb-4 pt-3 m-w-80 m-pb-10px
                fs-18 fc-39"
                >
                  <p className="w-50 ">수도권 1대리점</p>
                  <p className="w-50 ">울산 대리점</p>
                </div>

                <div
                  className="row-flex-center bd-bottom-ccc prt-medium w-80 pb-4 pt-3 m-w-80 m-pb-10px
                fs-18 fc-39"
                >
                  <p className="w-50 ">수도권 2대리점</p>
                  <p className="w-50 ">경남 1대리점</p>
                </div>

                <div
                  className="row-flex-center bd-bottom-ccc prt-medium w-80 pb-4 pt-3 m-w-80 m-pb-10px
                fs-18 fc-39"
                >
                  <p className="w-50 ">수도권 3대리점</p>
                  <p className="w-50 ">경남 2대리점</p>
                </div>

                <div
                  className="row-flex-center bd-bottom-ccc prt-medium w-80 pb-4 pt-3 m-w-80 m-pb-10px
                fs-18 fc-39"
                >
                  <p className="w-50 ">강원영동 대리점</p>
                  <p className="w-50 ">광주 대리점</p>
                </div>

                <div
                  className="row-flex-center bd-bottom-ccc prt-medium w-80 pb-4 pt-3 m-w-80 m-pb-10px
                fs-18 fc-39"
                >
                  <p className="w-50 ">충청 1대리점</p>
                  <p className="w-50 ">순천 대리점</p>
                </div>

                <div
                  className="row-flex-center prt-medium w-80 pb-4 pt-3 m-w-80 m-pb-10px
                fs-18 fc-39"
                >
                  <p className="w-50 ">충청 2대리점</p>
                </div>
              </div>
            </div>

            <div className="s3_content_right relative w-60 m-w-100">
              <img src={s3_bg} alt="" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
